export default __webpack_public_path__ + "53e062c3a564a74d18939d89628f2557.svg";